<template>
	<aside class="memo">
		<form class="text-right">
			<h2 class="title ma-0 text-left">관리자 메모</h2>
			<textarea
				class="new"
				v-model="memo"
				placeholder="내용을 입력하세요"
			></textarea>
			<button
				class="btn blue memo__input-btn"
				type="button"
				@click="inputMemo"
			>
				입력
			</button>
		</form>

		<dl>
			<template v-for="(item, idx) in memoList">
				<dt :key="'dt-' + item.id" class="d-flex">
					<b class="mr-auto">{{ item.nickName }}</b>
					<span>생성: {{ Util.format(item.createdAt) }}</span>
					<span v-if="item.updatedAt">
						/ 수정: {{ Util.format(item.updatedAt) }}</span
					>
				</dt>

				<dd :key="'dd-' + item.id">
					<textarea
						v-if="item.modifyMode"
						ref="memo"
						:value="item.memo"
					></textarea>

					<pre v-else>{{ item.memo }}</pre>

					<div class="command">
						<template v-if="item.modifyMode">
							<v-icon
								color="green"
								@click="modifyComplete(item.id)"
							>
								mdi-check-circle-outline
							</v-icon>
							<v-icon color="orange" @click="cancelMemo(idx)">
								mdi-clipboard-text-off-outline
							</v-icon>
						</template>
						<v-icon
							v-else-if="item.admin_account_id === adminRegister"
							@click="modifyMemo(item.id)"
						>
							mdi-pencil-box-outline
						</v-icon>
						<v-icon
							v-if="!item.modifyMode"
							color="red"
							@click="deleteMemo(item.id)"
							aria-label="삭제"
							>mdi-close-circle-outline</v-icon
						>
					</div>
				</dd>
			</template>
		</dl>
	</aside>
</template>
<script>
	import moment from 'moment';
	import { mapState } from 'vuex';

	export default {
		name: 'MemoBox',
		props: {
			refType: {
				type: String,
				required: true,
			},
			refId: {
				type: Number,
				required: true,
			},
			title: String,
		},
		data() {
			return {
				memo: '',
				memoList: [],
			};
		},
		computed: {
			...mapState({
				adminRegister: state => state.login.idRegister,
			}),
		},
		mounted() {
			this.getMemoList();
		},
		methods: {
			parsingDate(date) {
				return date
					? moment(date, 'YYYYMMDDHHmmss').format(
							'YYYY-MM-DD HH:mm:ss'
						)
					: '-';
			},
			async getMemoList() {
				try {
					const { data } = await this.$axiosSupport.get(
						`/admin/memo?ref_type=${this.refType}&ref_id=${this.refId}`
					);
					this.memoList = data.admin_memos.map(item => {
						item.modifyMode = false;
						item.createdAt = moment(item.created_at).format(
							'YYYY.MM.DD HH:mm:ss'
						);
						item.updatedAt =
							item.created_at === item.updated_at
								? ''
								: moment(item.updated_at).format(
										'YYYY.MM.DD HH:mm:ss'
									);
						return item;
					});
				} catch (err) {
					console.error(err);
					alert(
						'메모목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async inputMemo() {
				if (!this.memo.trim()) {
					alert('내용을 입력해주세요!');
					return;
				}
				try {
					const params = {
						admin_memo: {
							ref_type: this.refType,
							ref_id: this.refId,
							memo: this.memo,
						},
					};
					await this.$axiosSupport.post('/admin/memo', params);
					this.memo = '';
					this.getMemoList();
				} catch (err) {
					console.error(err);
					alert(
						'메모목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async modifyComplete(id) {
				const params = {
					admin_memo: {
						memo: this.$refs.memo[0].value,
					},
				};
				await this.$axiosSupport.put(`/admin/memo/${id}`, params);
				this.getMemoList();
			},
			cancelMemo(idx) {
				this.memoList[idx].modifyMode = false;
			},
			modifyMemo(id) {
				this.memoList.forEach(item => {
					item.modifyMode = item.id === id;
				});
			},
			async deleteMemo(id) {
				if (!confirm('정말 해당 메모를 삭제하나요?')) return;
				try {
					await this.$axiosSupport.delete(`/admin/memo/${id}`);
					this.getMemoList();
				} catch (err) {
					console.error(err);
					alert(
						'메모를 삭제하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	ASIDE.memo {
		position: fixed;
		top: 88px;
		right: 0;
		width: 400px;
		background-color: rgb(255, 238, 238);
		padding: 20px;
		height: calc(100vh - 88px);
		display: flex;
		flex-direction: column;

		.memo__input-btn {
			margin-top: 12px;
		}

		DL {
			margin: 0;
			padding: 0;
			flex: auto;
			overflow: auto;
			margin-top: 12px;

			DD {
				margin-bottom: 20px;
			}
		}

		TEXTAREA {
			width: 100%;
			border-color: grey;
		}

		.command {
			text-align: right;
		}
	}
</style>
